export default "__VITE_ASSET__Dg7yUCYo__"